import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import unfoldLess from '../../../../../src/icons/unfold_less.svg';
import unfoldMore from '../../../../../src/icons/unfold_more.svg';

import UserInfoIcon from '@material-ui/icons/AccountBoxOutlined';
import SignoutIcon from '@material-ui/icons/ExitToAppOutlined';
import { Box, Card, TableBody, Table, TableCell, TableRow, Tooltip, Modal, Fade, Backdrop } from '@material-ui/core';
import Button from '@material-ui/core/Button';

// Shared services
import { getNotifications } from 'services/notification';
import { getUserInfo } from 'services/userInfo';
import { updateIdiomaPreferidoUsuario } from '../../../../services/updateIdiomaPreferidoUsuario';

// Custom components
import NotificationList from './components/NotificationList';
import UserInfo from './components/UserInfo';
import SectionsTools from '../../../../views/Online/components/SectionsTools';
import {getLastStatusObjective} from '../../../../services/getLastStatusObjective'

//import {getIcon} from '../../../../utils/getIcon'
// Component styles
import styles from './styles';
import icons from '../../../../theme/icons.js'
import { lista_estados } from '../../../../data/status_error_icons.js';
import FeedbackIcon from '@mui/icons-material/Feedback';

import moment from 'moment'
import 'moment/locale/es'
import Feedback from './components/Feedback/index.jsx';
import { LanguageOutlined } from '@material-ui/icons';
import CheckIcon from '@material-ui/icons/Check';
import i18n, { changeLanguage } from '../../../../i18n';
import { withTranslation } from 'react-i18next';

moment.locale('es')


class Topbar extends Component {
    signal = true;

    /*  Link externo a servicios atentus */
    services = {
        "atWeb" : "https://atentus.com/monitoreoweb/",
        "atIVR" : "https://atentus.com/monitoreotelefonico/",
        "atMobile": "https://atentus.com/monitoreoaplicaciones/",
        "atMeta": "https://atentus.com/monitoreoweb/"

    };
   
    constructor(props) {
        super(props);
        this.state = {
            notifications: [],
            notificationsLimit: 4,
            notificationsCount: 0,
            notificationsEl: null,
            userDataEl: null,
            userData: [],
            userId: parseInt(sessionStorage.getItem('user')),
            token: (sessionStorage.getItem('key')),
            email: sessionStorage.getItem('email'),
            open:false,
            anchor:null,
            interval:'',
            slaOK:99.0,
            slaError:97.0,
            slaResponse:15.0,
            slaResponseError:29.0,
            value:{},
            sectionEl:null,
            checkedA: sessionStorage.getItem('extend_view') === "true",
            enEjecucion: Boolean(props.location.state?.fromObjective?.intervalo ?? undefined) ?? true,
            feedbackEl: null,
            languageEl: null,
            selectedLang: (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('i18nextLng')) || (i18n && i18n.language) || 'es',
            clienteId: parseInt(sessionStorage.getItem('client_id')) || null,
            isAdmin: Boolean(sessionStorage.getItem('admin_id')) || false
        };
    }

    async getNotifications() {
        try {
            const { notificationsLimit } = this.state;

            const { notifications, notificationsCount } = await getNotifications(
                notificationsLimit
            );

            if (this.signal) {
                this.setState({
                    notifications,
                    notificationsCount
                });
            }
        } catch (error) {
            return;
        }
    }

    async getUserInfo() {
        try {

            const { userData } = await getUserInfo(
                this.state.userId
            );

            if (this.signal) {
                this.setState({
                    userData
                });

            }
        } catch (error) {
            return;
        }
    }

    getIcon=(data)=>{
        var icon = <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO,scale:"0.4",transform:'scale(1)', transformOrigin:'left top 0px'}}/>
        if(data==='0'){
            icon =<i style={{...icons.sprite, ...icons.spriteOK,scale:"0.4",transform:'scale(1)', transformOrigin:'left top 0px'}}  />                               
        } else if (data in lista_estados){
            var icon = lista_estados[data].icono
            icon = <i style={{...icons.sprite, ...icons[icon],scale:"0.4",transform:'scale(1)', transformOrigin:'left top 0px'}}  />
        }
        return icon
    }


    componentDidMount() {
        this.signal = true;
        this.getNotifications();
        this.getUserInfo();
    }

    componentWillUnmount() {
        this.signal = false;
    }

    handleSignOut = () => {
        const { history } = this.props;
        localStorage.setItem('isAuthenticated', false);
        localStorage.clear()
        sessionStorage.clear()
        history.push('/sign-in');
    };

    handleShowNotifications = event => {
        this.setState({
            notificationsEl: event.currentTarget
        });
    };

    handleCloseNotifications = () => {
        this.setState({
            notificationsEl: null
        });
    };


    handleShowUserInfo = event => {
        this.setState({
            userDataEl: event.currentTarget
        });
    };

    handleSection = event => {
                this.setState({
                    sectionEl: event.currentTarget
                });
    };


    handleSectionClose = () => {
        this.setState({
            sectionEl: null
        });
    };
        

    handleCloseUserInfo = () => {
        this.setState({
            userDataEl: null
        });
    }
        handleSwitch = name=>event => {
            sessionStorage.setItem('extend_view', event.target.checked)
            this.setState({ 
                checkedA: event.target.checked 
            });
            this.props.onHandleExpand(event.target.checked)
    
    };

    openModal=(event)=>{
        const { t } = this.props;
        var interval=this.props.location.state?.fromObjective?.intervalo ?? '-'
        const {userId, token}=this.state
        var obj=(this.props.location.state.fromObjective.objetivo_id)
        if(interval==='0:01:00'){
            interval=t('topbar.interval.1m')
        }
        else if(interval==='0:05:00'){
            interval=t('topbar.interval.5m')
        }
        else if(interval==='0:07:00'){
            interval=t('topbar.interval.7m')
        }
        else if(interval==='0:10:00'){
            interval=t('topbar.interval.10m')
        }
        else if(interval==='0:15:00'){
            interval=t('topbar.interval.15m')
        }
        else if(interval==='0:20:00'){
            interval=t('topbar.interval.20m')
        }
        else if(interval==='0:30:00'){
            interval=t('topbar.interval.30m')
        }
        else if(interval==='0:40:00'){
            interval=t('topbar.interval.40m')
        }
        else if(interval==='1:00:00'){
            interval=t('topbar.interval.1h')
        }
        else if(interval==='1:30:00'){
            interval=t('topbar.interval.1h30m')
        }
        else if(interval==='2:00:00'){
            interval=t('topbar.interval.2h')
        }
        else if(interval==='6:00:00'){
            interval=t('topbar.interval.6h')
        }
        else if(interval==='12:00:00'){
            interval=t('topbar.interval.12h')
        }
        else if(interval==='24:00:00'){
            interval=t('topbar.interval.24h')
        }
        else if(interval==='7 days'){
            interval=t('topbar.interval.1week')
        }
        else if(interval==='-'){
            interval=t('topbar.interval.noInterval')
        }
        else{
            interval=t('topbar.interval.moreThanWeek')
        }
        const anchor = event.currentTarget
        getLastStatusObjective(obj, userId, token).then(value=>{
            if(value.estado==='Error'){
                value.estado=true
            }else{
                value.estado=false
            }
            this.setState({
                open:true,
                anchor,
                interval:interval,
                slaOK:this.props.location.state.fromObjective.sla_disponibilidad_ok,
                slaError:this.props.location.state.fromObjective.sla_disponibilidad_error,
                slaResponse:this.props.location.state.fromObjective.sla_rendimiento_ok,
                slaResponseError:this.props.location.state.fromObjective.sla_rendimiento_error,
                value:value
            })
        })
        
    }

    handleClose = () => {
        this.setState({
            anchor: null,
            open:false
        });
    };

    handleShowFeedback=(e)=>{
        this.setState({
            feedbackEl: e.currentTarget
        });
    }

    handleShowLanguage = (e) => {
        this.setState({ languageEl: e.currentTarget });
    }

    handleCloseLanguage = () => {
        this.setState({ languageEl: null });
    }

    handleSelectLanguage = (lng) => {
        // Cambio de idioma en frontend
        try {
            changeLanguage(lng);
        } catch (e) {
            if (i18n && i18n.changeLanguage) i18n.changeLanguage(lng);
        }
        try { moment.locale(lng); } catch(e) {}

        this.setState({ selectedLang: lng, languageEl: null });

        const token = sessionStorage.getItem('key');
        if (token) {
            updateIdiomaPreferidoUsuario(token, lng).catch(err => {
                // eslint-disable-next-line no-console
                console.warn('No se pudo actualizar el idioma preferido en backend', err);
            });
        }
    }

    handleCloseFeedback = () => {
        this.setState({
            feedbackEl: null,
        });
    };

    render() {
        const {
            classes,
            className,
            title,
            isSidebarOpen,
            onToggleSidebar,
            subtitle,
            location,
            t
        } = this.props;

        const { notifications, notificationsCount, notificationsEl, userDataEl, email,open,anchor, interval,slaError, slaOK, slaResponse,
             slaResponseError, value , sectionEl, checked, checkedA, feedbackEl, clienteId, isAdmin} = this.state;
        const rootClassName = classNames(classes.root, className);
        const showNotifications = Boolean(notificationsEl);
        const showUserData = Boolean(userDataEl);
        const section = Boolean(sectionEl);
        let titleBlock = null;
        // Si no tiene subtitulo, es una sección global
        if (!subtitle) {
            titleBlock = (
                <Typography className={classes.title} variant="h4">
                    {title}
                </Typography>
            );
        }else if(title==="Especial"){
            titleBlock = (
                <Typography className={classes.title} variant="h4">
                    {this.props.match.params.nombre_objetivo}
                </Typography>
            );
        
        } else {
            let objectiveStatus=location.state.fromObjective.estado
            var widthScreen={width:"40%", left:"20%"}
            if(window.innerWidth<=360){
                widthScreen={width:"80%", left:"20%"}
            }
            titleBlock = (
                <Box display='flex' alignItems='center' style={{flexWrap: 'wrap'}}>
                    <Badge
                        badgeContent={t('topbar.offline')}
                        variant="dot"
                        classes={{ badge: objectiveStatus === 'Uptime'  ? classes.customBadgeOnlineUp 
                                        :objectiveStatus === 'Downtime'  ? classes.customBadgeOnlineDown
                                        :objectiveStatus === 'Parcial'  ? classes.customBadgeOnlinePartial
                                        :objectiveStatus === 'No monitoreo'  ? classes.customBadgeOnlineNoMon  : null }}
                    >
                        <Button onClick={this.openModal}>
                            <Typography className={classes.title} variant='h6'>
                                {this.props.match.params.nombre_objetivo}
                            </Typography>
                        </Button>
                    </Badge>
                    <Popover open={open}
                        anchorEl={anchor}
                        onClose={this.handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        className={classes.popOverStatus}
                    >
                        <Card>
                            <Table size='small' className='table__cell--small-padding at-custom-form-table'>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            <Typography className={classes.rowPop}>{t('topbar.status.executionInterval')} </Typography>                                        
                                        </TableCell>
                                        <TableCell>
                                            <Typography className={classes.rowPop}>{interval}</Typography>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <Typography className={classes.rowPop}>{t('topbar.status.slaAvailability')} </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Box display='flex'>
                                                <Typography className={classes.rowPop}>{t('topbar.status.ok')} {slaOK}% | {t('topbar.status.error')} {slaError}%</Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <Typography className={classes.rowPop}>{t('topbar.status.slaPerformance')} </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Box display='flex'>
                                                <Typography className={classes.rowPop}>{t('topbar.status.ok')} {slaResponse}[s] | {t('topbar.status.error')} {slaResponseError}[s]</Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <Typography className={classes.rowPop}>{t('topbar.status.lastMeasurement')} </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography className={classes.rowPop}>{moment(value.fecha).format("HH:mm:ss DD-MM-YYYY A")}</Typography>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <Typography className={classes.rowPop}>{t('topbar.status.isp')} </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography className={classes.rowPop}>{value.nodo}</Typography>
                                        </TableCell>
                                    </TableRow>
                                    {value.estado ? (
                                        <>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography className={classes.rowPop}>{t('topbar.status.state')} </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography className={classes.rowPop}>{t('topbar.status.errorState')}</Typography>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography className={classes.rowPop}>{t('topbar.status.step')} </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography className={classes.rowPop}>{value.nombre_paso}</Typography>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography className={classes.rowPop}>{t('topbar.status.code')} </Typography>                                                    
                                                </TableCell>
                                                <TableCell style={{paddingTop: 5}}>
                                                   <Typography className={classes.rowPop} style={{height:"50px"}}>{this.getIcon(value.codigo)}</Typography>
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    ) : (
                                        <TableRow>
                                            <TableCell>
                                                <Typography className={classes.rowPop}>{t('topbar.status.state')} </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography className={classes.rowPop}>{t('topbar.status.okState')}</Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Card>
                    </Popover>
                    <Typography style={{color:
                            objectiveStatus === 'Uptime'  ? 'rgb(160, 246, 92)'
                            :objectiveStatus === 'Downtime'  ? 'rgb(255, 96, 89)'
                            :objectiveStatus === 'Parcial'  ? 'rgb(254, 254, 25)'
                            :objectiveStatus === 'No monitoreo'  ? 'rgb(241, 241, 241)'
                            :'rgb(241, 241, 241)'
                        }}
                    >
                        {this.props.match.params.nombre_servicio_unificado}
                    </Typography>
                    {window.innerWidth > 550 && !this.state.enEjecucion ? (
                        <Box position='absolute' style={{marginLeft: '16px', top: 35}}>
                            <Typography style={{color: 'rgb(241, 241, 241)', fontSize: 12}}>{t('topbar.noExecution')}</Typography>
                        </Box>
                    ) : null}
                </Box>
            );

        }
        
        const showFeedback = Boolean(feedbackEl);

        return (
            <Fragment>
                <div className={rootClassName}>
                    <Toolbar className={classes.toolbar}>
                        <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <IconButton
                            className={classes.menuButton}
                            onClick={onToggleSidebar}
                            variant="text">
                            {isSidebarOpen ? <img src={unfoldLess} style={{fill: "white", width: "34px", height: "34px"}}></img> : <img src={unfoldMore} style={{fill: "white", width: "34px", height: "34px"}}></img>}
                        </IconButton>
                        {/* Bloque de titulo, depende de la sección */}
                        {titleBlock}
                        </Box>
                        <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <Tooltip title={t('topbar.tooltip.feedback')}>
                            <IconButton className={classes.userInfoButton} onClick={this.handleShowFeedback}>
                                <FeedbackIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={t('topbar.tooltip.profile')}>
                            <IconButton
                                className={classes.userInfoButton}
                                onClick={this.handleShowUserInfo}>
                            <UserInfoIcon />     
                            </IconButton>
                        </Tooltip>
                        {clienteId === 1 || isAdmin ? (
                        <Tooltip title={t('topbar.tooltip.language')}>
                            <IconButton
                                className={classes.userInfoButton}
                                onClick={this.handleShowLanguage}>
                            <LanguageOutlined />     
                            </IconButton>
                        </Tooltip>
                        ):null}
                        <Typography className={classes.subtitle} variant="h6">
                            {/* @TODO: Agregar Nombre de Usuario - Correo desde API */}
                            {email}
                        </Typography>

                        {/* Sign-Out */}
                        <Tooltip title={t('topbar.tooltip.logout')}>
                            <IconButton
                                className={classes.signOutButton}
                                onClick={this.handleSignOut}>
                                <SignoutIcon />
                            </IconButton>
                        </Tooltip>
                        </Box>
                    </Toolbar>
                </div>
                <Popover
                    anchorEl={notificationsEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center'
                    }}
                    onClose={this.handleCloseNotifications}
                    open={showNotifications}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}>
                    <NotificationList
                        notifications={notifications}
                        onSelect={this.handleCloseNotifications}
                    />
                </Popover>

                <Popover
                    anchorEl={userDataEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center'
                    }}
                    onClose={this.handleCloseUserInfo}
                    open={showUserData}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}>
                    <UserInfo
                        userData={this.state.userData}
                        onSelect={this.handleCloseUserInfo}
                        onClose={this.handleCloseUserInfo}
                    />
                </Popover>
                <Popover
                    anchorEl={this.state.languageEl}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    onClose={this.handleCloseLanguage}
                    open={Boolean(this.state.languageEl)}
                >
                    <div style={{ padding: 8, minWidth: 180 }}>
                        {/* Simple language selector */}
                        {[{ code: 'es', label: t('topbar.language.spanish') }, { code: 'en', label: t('topbar.language.english') }, { code: 'pt', label: t('topbar.language.portuguese') }].map(lang => (
                            <div key={lang.code} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '8px 12px' }} onClick={() => this.handleSelectLanguage(lang.code)}>
                                <div style={{ flex: 1 }}>{lang.label}</div>
                                {this.state.selectedLang && this.state.selectedLang.startsWith(lang.code) ? <CheckIcon fontSize="small" color="primary" /> : null}
                            </div>
                        ))}
                    </div>
                </Popover>
                <Popover
                    anchorEl={sectionEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center'
                    }}
                    onClose={this.handleSectionClose}
                    open={section}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}>
                    <SectionsTools/>
                </Popover>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showFeedback}
                    onClose={this.handleCloseFeedback}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                    >
                    <Fade in={showFeedback}>
                        <Feedback handleCloseFeedback={this.handleCloseFeedback}/>
                    </Fade>
                </Modal>
            </Fragment>
        );
    }
}

Topbar.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    isSidebarOpen: PropTypes.bool,
    onToggleSidebar: PropTypes.func,
    title: PropTypes.string
};

Topbar.defaultProps = {
    onToggleSidebar: () => { }
};

export default compose(
    withRouter,
    withStyles(styles),
    withTranslation()
)(Topbar);